import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
      fill="#016FD0"
    />
    <path
      d="M6.62771 8.57171L7.34758 10.2784H5.90785L6.62771 8.57171ZM21.6327 8.64472H18.8561V9.40222H21.586V10.5339H18.8561V11.3735H21.6327V12.0489L23.5679 10.0046L21.6327 7.86897V8.64472ZM8.50685 6.50913H12.2371L13.0691 8.27053L13.8357 6.5H23.5119L24.5215 7.58605L25.5593 6.5H30L26.7185 10.0137L29.972 13.5H25.4564L24.4467 12.4139L23.3997 13.5H7.6187L7.1606 12.4139H6.10417L5.64608 13.5H2L5.06644 6.5H8.26377L8.50685 6.50913ZM16.5937 7.49479H14.4995L13.0972 10.7164L11.5826 7.49479H9.50718V11.8755L7.5813 7.49479H5.72087L3.49583 12.5143H4.94491L5.403 11.4283H7.84307L8.30117 12.5143H10.8441V8.92764L12.4801 12.5143H13.5927L15.2194 8.93677V12.5143H16.5843L16.5937 7.49479ZM25.3068 10.0137L27.6721 7.49479H25.9706L24.4748 9.06454L23.0257 7.49479H17.5285V12.5235H22.9509L24.4561 10.9355L25.9052 12.5235H27.6534L25.3068 10.0137Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;